import {createStackNavigator} from '@react-navigation/stack'

import {ApplicationActivationWorkflowStackParams} from 'src/workflows/types'

const ApplicationActivationWorkflowStackNav =
  createStackNavigator<ApplicationActivationWorkflowStackParams>()

export {ApplicationActivationWorkflowStackNav}
